module.exports = __webpack_public_path__ + "static/jss-logo-f7208f17b1c65bcfb557a6ced8b18237.webp";